import { render, staticRenderFns } from "./OrderFormComponent.vue?vue&type=template&id=4f74783d&"
import script from "./OrderFormComponent.vue?vue&type=script&lang=js&"
export * from "./OrderFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports